import { DocumentApi } from 'woofwoof-api';
import client, { axiosBaseUrl } from './client';

export const documentApi = new DocumentApi(
  {
    basePath: axiosBaseUrl,
    isJsonMime: () => false,
  },
  undefined,
  //@ts-ignore
  client,
);
